import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { getTranslations } from '@translations';
import InputDesktop from './InputDesktop';
import SearchContent from './SearchContent';
import { useHeaderContext } from '../../../../HeaderContext';
import { extractSearchValue } from './search-utils';

import styles from './styles/index.module.scss';

/**
 * Please note that this component contains id and classnames (which do not follow
 * CSS module naming strategy) that are required to show the search bar
 * implementation with Manomano-sf
 * i.e =>
 * 1) id = searchbar-form, searchbar-results-wrapper, search-frame-cancel
 * 2) classes = searchbar, searchbar__content
 */

const Search = ({ isB2B, className, isHidden }) => {
  const { platformBaseUrl } = useHeaderContext();
  const translations = getTranslations();
  const url = translations('header.subheader.search.url');

  const placeholder = isB2B
    ? translations('header.subheader.search.b2b.placeholder')
    : translations('header.subheader.search.b2c.placeholder');
  const [value, setValue] = useState('');
  const onChange = inputValue => setValue(inputValue);

  const searchClassName = cn(styles.search, className, {
    [styles.isHidden]: isHidden,
  });

  useEffect(() => {
    const answer = extractSearchValue({
      url: window.location.href,
      searchPathname: translations('header.subheader.search.url'),
    });
    setValue(answer);
  }, []);

  return (
    <div className={searchClassName}>
      <form
        id="searchbar-form"
        className={cn('searchbar', styles.searchbar)}
        method="get"
        action={`${platformBaseUrl}${url}`}
      >
        <InputDesktop
          color={isB2B ? 'secondary' : 'primary'}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
        />
        <div className="searchbar__content" id="searchbar-results-wrapper">
          <span id="search-frame-cancel" />
          <SearchContent />
        </div>
      </form>
    </div>
  );
};

Search.propTypes = {
  isB2B: PropTypes.bool.isRequired,
  className: PropTypes.string,
  isHidden: PropTypes.bool,
};

Search.defaultProps = {
  className: null,
  isHidden: true,
};

Search.displayName = 'Search';

export default Search;
